import { NavLink } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.label,
      item: item.path ? `https://sakuracomic.cn${item.path}` : undefined,
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <nav aria-label="面包屑导航" className="flex items-center gap-1.5 text-sm">
        {items.map((item, index) => (
          <span key={index} className="flex items-center gap-1.5">
            {index > 0 && (
              <i className="ri-arrow-right-s-line text-foreground-600 text-xs"></i>
            )}
            {item.path && index < items.length - 1 ? (
              <NavLink
                to={item.path}
                className="text-foreground-600 hover:text-accent-500 transition-colors whitespace-nowrap"
              >
                {item.label}
              </NavLink>
            ) : (
              <span className={index === items.length - 1 ? 'text-foreground-950 font-medium' : 'text-foreground-600'}>
                {item.label}
              </span>
            )}
          </span>
        ))}
      </nav>
    </>
  );
}